module.exports = __webpack_public_path__ + "chosen-sprite@2x.cb0d09c93b99c5cab6848147fdb3d7e4.png";